<ng-container *ngIf="myaccountAccountInfo$ | async as myaccount">
  <div class="myaccount-account-info" [ngClass]="freightPrice && freightPrice !== '$0' ? 'snah' : ''">
    <div class="myaccount-heading">
      <h2>{{ 'myAccount.accountInfo' | cxTranslate }}</h2>
      <a
        *ngIf="myaccount?.isB2BAdmin === true && isEditAccountInfoEnabled$ | async"
        [routerLink]="['/my-account/account-information']"
      >
        {{ 'common.edit' | cxTranslate }}
      </a>
    </div>
    <div class="myaccount-wrapper">
      <div class="account-details main-address">
        <h3 class="account-label" *ngIf="myaccount?.mainAddress; else emptyMainAddress">
          {{ 'myAccount.mainAddress' | cxTranslate }}
        </h3>
        <app-tooltip-text
          class="account-info"
          [tooltipContent]="myaccount?.mainAddress?.formattedAddress"
          [content]="showAddress(myaccount?.mainAddress) | async"
          [charactersLimit]="350"
          placement="bottom"
        >
        </app-tooltip-text>
        <ng-template #emptyMainAddress>
          <h3 class="account-label" [style.height.px]="48"></h3>
          <span class="account-info" [style.width.px]="231">{{ myaccount?.mainAddress?.formattedAddress }}</span>
        </ng-template>
      </div>
      <div class="delivery-address">
        <h3 class="account-label" *ngIf="myaccount?.defaultAddress; else emptyDeliveryAddress">
          {{ 'myAccount.defaultDeliveryAddress' | cxTranslate }}
        </h3>
        <app-tooltip-text
          class="account-info"
          [tooltipContent]="myaccount?.defaultAddress?.formattedAddress"
          [content]="showAddress(myaccount?.defaultAddress) | async"
          placement="bottom"
        >
        </app-tooltip-text>
        <ng-template #emptyDeliveryAddress>
          <h3 class="account-label" [style.height.px]="48"></h3>
          <span class="account-info" [style.width.px]="231">{{ myaccount?.defaultAddress?.formattedAddress }}</span>
        </ng-template>
      </div>
      <div class="billing-address">
        <h3 class="account-label" *ngIf="myaccount?.defaultBillingAddress; else emptyBillingAddress">
          {{ 'myAccount.billingAddress' | cxTranslate }}
        </h3>
        <app-tooltip-text
          class="account-info"
          [tooltipContent]="myaccount?.defaultBillingAddress?.formattedAddress"
          [content]="showAddress(myaccount?.defaultBillingAddress) | async"
          placement="bottom"
        >
        </app-tooltip-text>
        <ng-template #emptyBillingAddress>
          <h3 class="account-label" [style.height.px]="48"></h3>
          <span class="account-info" [style.width.px]="231">{{
            myaccount?.defaultBillingAddress?.formattedAddress
          }}</span>
        </ng-template>
      </div>
    </div>
    <div class="freight" *ngIf="freightPrice && freightPrice !== '$0' && showActiveSnahCountry$ | async">
      <mat-icon svgIcon="freight-icon"></mat-icon>
      <span>{{ 'checkout.group.customFreight.freight' | cxTranslate : { freightLevel: freightPrice } }} </span>
    </div>
  </div>
</ng-container>
